import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './FieldCheckbox.scss'

const FieldCheckbox = ({ fieldId, error, checked, value, ...rest }) => {
	return (
		<span>
			<span styleName="mini-label">
				{checked ? 'Yes!' : 'Nope.'}
			</span>
			<input
				{...rest}
				checked={checked}
				id={fieldId}
				styleName={error ? 'input-error' : 'checkbox'}
			/>
		</span>
	)
}
FieldCheckbox.propTypes = {
	id: React.PropTypes.string,
	error: React.PropTypes.bool
}

export default CSSModules(FieldCheckbox, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Form/FieldCheckbox.js